import { appConfig, headerConfig, refineHeader } from "../../config";

export const merchantService = {
  get_merchant_details,
  get_merchant_list,
  add_merchant,
  get_merchant_type,
  add_merchant_location,
  add_merchant_store,
  delete_merchant,
  get_merchant_location_details,
  get_merchant_store_details,
  update_merchant,
  update_merchant_storefront,
  delete_merchant_location,
  delete_merchant_store,
  get_merchant_details_id,
  get_default_tax,
  get_lat_long,
  UploadLogo
};

function add_merchant(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}merchant/add`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function add_merchant_location(postData, merchantID) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(
    `${appConfig.api.url}merchant/merchant-location/${merchantID}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function add_merchant_store(postData, merchantID) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(
    `${appConfig.api.url}merchant/merchant-store/${merchantID}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

// function get_merchant_list(formData) {
//   refineHeader();
//   const requestOptions = {
//     method: "POST",
//     headers: headerConfig.headerDatas,
//     mode: "cors",
//     body: JSON.stringify(formData)
//   };

//   return fetch(`${appConfig.api.url}merchant/list`, requestOptions)
//     .then(handleResponse)
//     .then(data => {
//       return data;
//     });
// }

function get_merchant_list(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  var routeName;

  if(formData.pageName == "merchantListingPage"){
    routeName = "list";
  }else{
    routeName = "listName";
  }

  return fetch(`${appConfig.api.url}merchant/`+routeName, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function get_merchant_type() {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(`${appConfig.api.url}merchant/merchant-type`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function delete_merchant(merchantID) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(
    `${appConfig.api.url}merchant/delete/${merchantID}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function delete_merchant_location(merchantID, locID) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify({ merchantID: merchantID })
  };

  return fetch(
    `${appConfig.api.url}merchant/delete-location/${locID}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function delete_merchant_store(merchantID, colorID) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify({ merchantID: merchantID })
  };

  return fetch(
    `${appConfig.api.url}merchant/delete-store/${colorID}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function update_merchant(postData) {
  refineHeader();
  let requestOptions;
  if(!postData.merchantName){
    requestOptions = {
      method: "POST",
      headers: headerConfig.headerImage,
      mode: "cors",
      body: postData
    };
  }
  else
  {
    requestOptions = {
      method: "POST",
      headers: headerConfig.headerDatas,
      mode: "cors",
      body: JSON.stringify(postData)
    };
  }

  return fetch(`${appConfig.api.url}merchant/edit`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function update_merchant_storefront(postData) {
  refineHeader();
  let requestOptions;
    requestOptions = {
      method: "POST",
      headers: headerConfig.headerDatas,
      mode: "cors",
      body: JSON.stringify(postData)
    };

  return fetch(`${appConfig.api.url}merchant/edit-storefront`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function UploadLogo(postData) {
  refineHeader();
  let requestOptions; 
  requestOptions = {
    method: "POST",
    headers: headerConfig.headerImage,
    mode: "cors",
    body: postData
  };

  return fetch(`${appConfig.api.url}merchant/upload-logo`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function get_merchant_details(merchantIdParams) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(
    `${appConfig.api.url}merchant/detail/${merchantIdParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function get_merchant_details_id(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}merchant/merchant-detail`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function get_merchant_location_details(merchantIdParams) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(
    `${appConfig.api.url}merchant/location/${merchantIdParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function get_merchant_store_details(merchantIdParams) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(
    `${appConfig.api.url}merchant/store/${merchantIdParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function get_default_tax(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}public-city/state-tax-rate`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function get_lat_long(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}merchant/lat-long`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}



// WEBPACK FOOTER //
// ./src/app/services/API/merchantService.js